export default {
  abonnements: [],
}
